import React from 'react';
import './pageheader.sass';

class PageHeader extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  toggleOpen = () => {
    this.setState({ open: !this.state.open });
  }

  render() {
    return (
      <header className="navbar fixed-top navbar-expand-lg navbar-light bg-light">
        <button onClick={this.props.toggleOpenNavBar} className="btn btn-link">
          <span className="ico-sandwich"></span>
        </button>
        <a className="navbar-brand" href="/">Cacib</a>
    </header>
    );
  }
}

export default PageHeader;